import { render, staticRenderFns } from "./LookupDisplay.vue?vue&type=template&id=c43c3844&scoped=true&"
import script from "./LookupDisplay.vue?vue&type=script&lang=js&"
export * from "./LookupDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43c3844",
  null
  
)

export default component.exports